import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/index' // 引入路由配置文件 routes.js
import echarts from 'echarts'
import jquery from 'jquery'
import axios from "axios"
import html2canvas from "html2canvas"
import cookies from 'js-cookie'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(ElementUI, { locale })
Vue.prototype.$ = jquery
Vue.prototype.$echarts = echarts
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    // 在这里进行权限检查或者其他逻辑判断
    if (!cookies.get("token") && to.path !== '/login') {
      next('/login'); // 跳转到登录页面
    } else {
      next(); // 继续导航
    }
  });
new Vue({
    router, // 注入 Vue Router 实例
    html2canvas,
    render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js